import React from 'react';

const BillingIcon = (props) => {  
  const {size,color}=props;
  return (
<svg width={size} height={size} viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M10.0008 7.49896V6.66528" stroke={color} stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M10.0008 12.5012V13.3349" stroke={color} stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M8.55508 11.9056C8.76869 12.2729 9.16016 12.5003 9.58504 12.5039H10.4988C11.0898 12.5035 11.5878 12.0626 11.66 11.4761C11.7322 10.8895 11.3559 10.341 10.7827 10.1973L9.22013 9.80472C8.64688 9.66094 8.27064 9.11251 8.34284 8.52593C8.41504 7.93935 8.91305 7.49852 9.50405 7.49805H10.4178C10.8418 7.50099 11.2329 7.72731 11.4468 8.09353" stroke={color} stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M10.0002 2.49707C14.1441 2.49707 17.5033 5.85633 17.5033 10.0002C17.5033 14.1441 14.1441 17.5033 10.0002 17.5033C5.85633 17.5033 2.49707 14.1441 2.49707 10.0002C2.49707 5.85633 5.85633 2.49707 10.0002 2.49707" stroke={color} stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M10.0002 2.49707C14.1441 2.49707 17.5033 5.85633 17.5033 10.0002C17.5033 14.1441 14.1441 17.5033 10.0002 17.5033C5.85633 17.5033 2.49707 14.1441 2.49707 10.0002C2.49707 5.85633 5.85633 2.49707 10.0002 2.49707" stroke={color} stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
</svg>
 );
};
BillingIcon.defaultProps = {
  size: 24,
  color:"#0623C1",
};

export default BillingIcon;